import { MapPosition } from '../types';
import { getWindowKonvaObject } from './konva/getWindowKonvaObject';

export const getStagePositionStartingFromPoint = (position: MapPosition) => {
  const stage = getWindowKonvaObject().stages[0];
  if (!stage) return;
  return {
    x: (position.x - stage.getAbsolutePosition().x) / stage.scaleX(),
    y: (position.y - stage.getAbsolutePosition().y) / stage.scaleY()
  };
};
